import styled from 'styled-components'

interface StepProps {
  showBorder?: boolean
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 10px 0 0 0;

  .dropdown {
    min-width: none;
    width: 100%;
  }
  
  .LinkPlanModal__FormTitle {
    align-self: center;
    margin-top: 10px;
  }

  .LinkPlanModal__Label {
    margin: 20px 0 5px 0;
    align-self: start;
    color: #898989;
  }


  .LinkPlanModal__Select {
    max-width: none;
    width: 100%;
    margin-bottom: 10px;
    > div {
      margin: 0;
    }
  }
  .LinkPlanModalSuccess__SuccessTitle {
    margin-top: 10px;
    text-align: center;
  }

  .LinkPlanModalSuccess__SuccessMessageWrapper {
    display: flex;
    gap: 15px;
    max-width: none;
    margin-bottom: 40px;
    padding: 20px;
  }

  .LinkPlanModal__WarningMessageWrapper {
    padding: 20px;
    gap: 20px;
    margin-top: 17px;

    b {
      color: #1F35B5;
      cursor: pointer;
    }
  }
`

export const PlanImage = styled.img`
  margin-top: 30px;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  width: 130px;
  height: 70px;
`

export const FormWrapper = styled.div`
  width: 100%;
  margin-top: 20px;

  .LinkPlanModal__PlanDropdown {
    margin-bottom: 10px;
  }
`

export const Content = styled.div``

export const Step = styled.div<StepProps>`
  margin-top: 30px;
  padding-bottom: 30px;
  border-bottom: ${({ showBorder }) => showBorder ? '1px solid #E2E2E2' : 'none'};
`

export const StepImage = styled.img`
  width: 313px;
`

export const StepContent = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 10px;
`

export const StepCount = styled.div`
  background: #1F35B5;
  max-height: 30px;
  min-width: 30px;  
  border-radius: 50px;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
`
